
export const gerenciaChefiaRouter = [{
  path: "/" + process.env.VUE_APP_BASE_URL + "/gerencia",
  component: () => import("@/paginas/gerencia/gerencia.vue"),
  meta: {
    auth: ['CHEFIAGERENCIA']
  },
  children: [
    {
      path: "pendente",
      name: "CHEFIAGERENCIA_PENDENTE",
      component: () => import("@/paginas/gerencia/pendente.vue"),
      meta: {
        auth: ['CHEFIAGERENCIA']
      },
    },
    {
      path: "concluidos",
      name: "CHEFIAGERENCIA_CONCLUIDO",
      component: () => import("@/paginas/gerencia/concluido.vue"),
      meta: {
        auth: ['CHEFIAGERENCIA']
      },
    },
    {
      path: "rejeitados",
      name: "CHEFIAGERENCIA_REJEITADOS",
      component: () => import("@/paginas/gerencia/rejeitados.vue"),
      meta: {
        auth: ['CHEFIAGERENCIA']
      },
    },
  ],
}]
